<template>
  <div>
    <slot name="logo" v-bind="{ pageLogo }" />
  </div>
</template>

<script>
export default {
  props: ['bot'],
  computed: {
    pageLogo() {
      const pageid = this.bot.facebook_page_id ? this.bot.facebook_page_id : this.bot.pageid
      let imgUrl = `https://graph.facebook.com/${pageid}/picture?width=300&height=300&SameSite=None`
      if (this.bot.theme == 'summitcapital') {
        if (pageid === '495271297476302') {
          //prod
          imgUrl =
            'https://zwizai.s3.amazonaws.com/ecommerce/1670383390836image-20221206-150255.png'
        } else if (['104337274602594', '106342852217021'].includes(pageid)) {
          //uat
          imgUrl =
            'https://zwizai.s3.amazonaws.com/ecommerce/1672218178995summit-capital-uat-profile.png'
        }
      }
      return this.bot.pagelogo ? this.bot.pagelogo : imgUrl
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/BotLogoManager.vue